export function prepareVarFilter(variables, filter, getElementId) {
	if (!(variables?.length > 0) || !(filter?.length > 0)) return []
	const varIDs = variables.map((el) => getElementId(el))
	const varFilter = filter.filter((el) => varIDs.includes(el.id))
	return varFilter
}